import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import CbtVenueSelectionForm from '@cont/SeeAll/TestSeriesListing/TestSeriesRevamp/CbtVenueSelectionForm';
import { getCbtActivationDelayMessage } from './cbtAddonUtils';

const VenueWrapper = styled.div`
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: 200px;
  padding: ${Spacings.SPACING_6B};
  background-color: var(--color-base-0);
  border: 1px solid var(--color-divider);
  border-radius: ${Spacings.SPACING_4B};
  text-align: left;

  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_4B};
    margin-bottom: 240px;
    padding: ${Spacings.SPACING_4B};
    border-radius: ${Spacings.SPACING_2B};
  }
`;

const Title = styled(Typography)`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.H4};
  line-height: 30px;
  margin-bottom: ${Spacings.SPACING_6B};

  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H5};
    line-height: 26px;
    margin-bottom: ${Spacings.SPACING_4B};
  }
`;

const ActivationDelayBanner = styled.div`
  margin-top: ${Spacings.SPACING_5B};
  padding: ${Spacings.SPACING_2B};
  border-radius: ${Spacings.SPACING_2B};
  background-color: var(--color-i-green-18);
  text-align: center;
`;

const ActivationDelayText = styled(Typography)`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.P2};
  line-height: 18px;
  color: var(--color-i-green);
`;

const BundleCbtVenueSelection = ({
  programmeUid,
  activationDelayHours,
  onVenueChange,
  isMobile = false
}) => {
  if (!programmeUid) return null;

  const activationDelayMessage =
    getCbtActivationDelayMessage(activationDelayHours);

  return (
    <VenueWrapper>
      <Title variant="h4">Fill your details</Title>
      <CbtVenueSelectionForm
        programmeUid={programmeUid}
        isMobile={isMobile}
        hideProceedButton
        onVenueChange={onVenueChange}
      />
      {activationDelayMessage && (
        <ActivationDelayBanner>
          <ActivationDelayText variant="p2">
            {activationDelayMessage}
          </ActivationDelayText>
        </ActivationDelayBanner>
      )}
    </VenueWrapper>
  );
};

export default BundleCbtVenueSelection;
